var map = {
	"./actions/Allocation.js": "./src/js/actions/Allocation.js",
	"./admin.js": "./src/js/admin.js",
	"./allocation.js": "./src/js/allocation.js",
	"./alreadyAllocated.js": "./src/js/alreadyAllocated.js",
	"./customer-select.js": "./src/js/customer-select.js",
	"./jsonToExcel.js": "./src/js/jsonToExcel.js",
	"./nav.js": "./src/js/nav.js",
	"./product.js": "./src/js/product.js",
	"./rd/campaignStats.js": "./src/js/rd/campaignStats.js",
	"./rd/order.js": "./src/js/rd/order.js",
	"./rd/portablesStats.js": "./src/js/rd/portablesStats.js",
	"./rd/reports.js": "./src/js/rd/reports.js",
	"./resource-share.js": "./src/js/resource-share.js",
	"./table-parser.js": "./src/js/table-parser.js",
	"./vendors/allocatedOrder.js": "./src/js/vendors/allocatedOrder.js",
	"./workstations/poNeeded.js": "./src/js/workstations/poNeeded.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/js sync recursive \\.js$";